export enum PaymentResponseStatus {
  AGUARDANDO_AUTORIZACAO = 'AGUARDANDO_AUTORIZACAO',
  PENDENTE_DEMAIS_APROVACOES = 'PENDENTE_DEMAIS_APROVACOES',
  AUTORIZADA_AGUARDANDO_EFETIVACAO = 'AUTORIZADA_AGUARDANDO_EFETIVACAO',
  TRANSFERENCIA_REALIZADA = 'TRANSFERENCIA_REALIZADA',
  AGUARDANDO_CONFIRMACAO_IF_DESTINO = 'AGUARDANDO_CONFIRMACAO_IF_DESTINO',
  TRANSFERENCIA_REPROVADA = 'TRANSFERENCIA_REPROVADA',
  TRANSFERENCIA_EXPIRADA = 'TRANSFERENCIA_EXPIRADA',
  ERRO_TRANSFERENCIA = 'ERRO_TRANSFERENCIA',
  REJEITADA_IF_DESTINO = 'REJEITADA_IF_DESTINO',
  CANCELADA_TESOURARIA = 'CANCELADA_TESOURARIA',
  CANCELADA_CLIENTE = 'CANCELADA_CLIENTE',
  CANCELADA_POR_ENCERRAMENTO_DE_CONTA = 'CANCELADA_POR_ENCERRAMENTO_DE_CONTA',
  CANCELADA_PELO_SISTEMA_DE_OPEN_BANKING = 'CANCELADA_PELO_SISTEMA_DE_OPEN_BANKING',

  AGUARDANDO_ANALISE_ANTIFRAUDE = 'AGUARDANDO_ANALISE_ANTIFRAUDE',
  CANCELADA_SUSPEITA_FRAUDE = 'CANCELADA_SUSPEITA_FRAUDE',

  // transferencia realizada mesmo passando pelo anti fraude
  AUTORIZADA_PELO_ANTI_FRAUDE = 'AUTORIZADA_PELO_ANTI_FRAUDE',
  TIME_OUT_DO_ANTI_FRAUDE = 'TIME_OUT_DO_ANTI_FRAUDE',

  //Matheus da Lydians disse que essas situações não acontecem na Omni
  ENVIADA_PARA_INTEGRACAO = 'ENVIADA_PARA_INTEGRACAO',
  PROTOCOLO_RECEBIDO_DA_INTEGRACAO = 'PROTOCOLO_RECEBIDO_DA_INTEGRACAO',
  TIME_OUT_DA_INTEGRACAO = 'TIME_OUT_DA_INTEGRACAO',
  REJEITADA_PELA_INTEGRACAO = 'REJEITADA_PELA_INTEGRACAO',
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-securities/models/payment-response.enum.ts